export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-2.c6d79197.png";